import { storypostPrivacy, storypostTerms } from './storypost';
import { docreaderPrivacy, docreaderTerms } from './docreader';
import { dailyHoroscopePrivacy, dailyHoroscopeTerms } from './dailyHoroscope';
import { driveReadyPrivacy, driveReadyTerms } from './driveReady';
import { speedTestPrivacy, speedTestTerms } from './speedTest';
import { teleprompterPrivacy, teleprompterTerms } from './teleprompter';

export const internalLegalDocs = {
  'drive-ready': {
    privacy: driveReadyPrivacy,
    terms: driveReadyTerms,
  },
  'daily-horoscope': {
    privacy: dailyHoroscopePrivacy,
    terms: dailyHoroscopeTerms,
  },
  docreader: {
    privacy: docreaderPrivacy,
    terms: docreaderTerms,
  },
  'speed-test': {
    privacy: speedTestPrivacy,
    terms: speedTestTerms,
  },
  teleprompter: {
    privacy: teleprompterPrivacy,
    terms: teleprompterTerms,
  },
  storypost: {
    privacy: storypostPrivacy,
    terms: storypostTerms,
  },
};

export function getInternalLegalDoc(appSlug, type) {
  return internalLegalDocs[appSlug]?.[type];
}
